<template>
  <div :class="{ 'c-article-social-buttons--right': align === 'right' }" class="c-article-social-buttons">
    <p data-test-label>{{ label }}</p>
    <div class="c-article-social-buttons__icons">
      <ShareNetwork
        v-for="social in socialNetworks"
        :key="social.alt"
        :media="imageSrc"
        :network="social.network"
        :title="title"
        :url="social.url"
        class="c-article-social-buttons__icon"
        data-test-share
      >
        <img :alt="social.alt" :class="social.class" :src="social.logo" />
      </ShareNetwork>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, useNuxtApp } from '#imports'
import { getConfig } from '@b2ag/micro-front-tools'
import x from '../../assets/images/x.svg'
import linkedin from '../../assets/images/linkedin.svg'
import facebook from '../../assets/images/facebook.svg'
import ShareNetwork from '@b2ag/vue-social-sharing'

export default defineComponent({
  name: 'PArticleSocialButtons',
  props: {
    align: {
      type: String,
      default: 'left',
    },
    title: {
      type: String,
    },
    imageSrc: {
      type: String,
    },
    label: {
      type: String,
      default: 'Partager l’article :',
    },
  },
  components: {
    ShareNetwork,
  },
  setup() {
    const nuxtApp = useNuxtApp()
    const prefix = getConfig('BASE_URL').includes('localhost') ? 'http' : 'https'
    const href =
      typeof window !== 'undefined'
        ? window.location.href
        : prefix + '://' + getConfig('BASE_URL') + nuxtApp.ssrContext.url

    const socialNetworks = computed(() => [
      {
        url: href,
        alt: 'x',
        network: 'twitter',
        class: 'c-article-social-buttons__icon-x',
        logo: x,
      },
      {
        url: href,
        alt: 'LinkedIn',
        network: 'linkedin',
        class: 'c-article-social-buttons__icon-linkedin',
        logo: linkedin,
      },
      {
        url: href,
        alt: 'Facebook',
        network: 'facebook',
        class: 'c-article-social-buttons__icon-facebook',
        logo: facebook,
      },
    ])

    return {
      socialNetworks,
    }
  },
})
</script>
<style lang="scss">
.c-article-social-buttons {
  display: flex;
  align-items: center;

  p {
    color: var(--color-grey-dark);
    font-size: var(--font-size-m);
    margin-right: var(--spacing-3);
  }

  .c-article-social-buttons__icons {
    display: flex;
    gap: var(--spacing-3);

    .c-article-social-buttons__icon {
      width: 3.2rem;
      height: 3.2rem;
      border-radius: var(--border-radius-2);
      background-color: var(--color-blue-lighter);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .c-article-social-buttons__icon-twitter {
      width: 18px;
      height: 13px;
    }

    .c-article-social-buttons__icon-linkedin {
      width: 15px;
      height: 16px;
    }

    .c-article-social-buttons__icon-facebook {
      width: 9px;
      height: 16px;
    }
  }
}
</style>
